import React from 'react';
import Grid from "@mui/material/Grid";

const FlexGrid = ({children,sx,...otherProps}) => {
    const alignItems = otherProps?.alignItems ?? 'center';
    return (
        <Grid sx={{display: 'flex', alignItems,...sx}} {...otherProps}>
            {children}
        </Grid>
    );
};

export default FlexGrid;